import { Platform, Switch, SwitchProps } from 'react-native';
import { useTheme } from '@/contexts/ThemeContext';

/**
 * Themed Switch that properly applies accent color on all platforms.
 * On web, React Native's Switch ignores trackColor, so we inject CSS via style.
 */
export default function ThemedSwitch(props: SwitchProps) {
  const { theme } = useTheme();
  const activeColor = props.trackColor && typeof props.trackColor === 'object'
    ? props.trackColor.true ?? theme.colors.accent
    : theme.colors.accent;
  const inactiveColor = props.trackColor && typeof props.trackColor === 'object'
    ? props.trackColor.false ?? theme.colors.surfaceVariant
    : theme.colors.surfaceVariant;

  if (Platform.OS === 'web') {
    return (
      <Switch
        {...props}
        trackColor={{ false: inactiveColor, true: activeColor }}
        thumbColor={props.thumbColor ?? theme.colors.text}
        // @ts-ignore - web style override
        style={[
          props.style,
          {
            // Web: override the accent-color CSS property
            // @ts-ignore
            accentColor: activeColor,
          },
        ]}
        activeThumbColor={activeColor}
      />
    );
  }

  return (
    <Switch
      {...props}
      trackColor={{ false: inactiveColor, true: activeColor }}
      thumbColor={props.thumbColor ?? theme.colors.text}
    />
  );
}
